/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Aria_Legal_LinksInputs */

const en_footer_aria_legal_links = /** @type {(inputs: Footer_Aria_Legal_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal links`)
};

const es_footer_aria_legal_links = /** @type {(inputs: Footer_Aria_Legal_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlaces legales`)
};

/**
* | output |
* | --- |
* | "Legal links" |
*
* @param {Footer_Aria_Legal_LinksInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const footer_aria_legal_links = /** @type {((inputs?: Footer_Aria_Legal_LinksInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Aria_Legal_LinksInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_aria_legal_links(inputs)
	return en_footer_aria_legal_links(inputs)
});